import { BASE } from "./shop";

async function handle(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || "No pudimos completar la solicitud.");
  return data;
}

export async function createOrder({ cart, address, token }) {
  const res = await fetch(`${BASE}/api/orders/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json", token: token || "" },
    body: JSON.stringify({ cart, address }),
  });
  return handle(res);
}

export async function fetchMyOrders(token) {
  const res = await fetch(`${BASE}/api/orders/mine`, { headers: { token: token || "" } });
  return handle(res);
}
